import { Component, Input } from '@angular/core';

@Component({
  selector: 'payment-autopay-badge',
  templateUrl: './autopay-badge.component.html',
  styleUrls: ['./autopay-badge.component.scss'],
})
export class AutopayBadgeComponent {
  @Input() isAutopayEnabled: boolean;

  constructor() {}
}
